import { useSelector } from "react-redux";
import { getCurrentUser } from "../../../helpers/selectors";
import useChangeCurrentWorkspace from "../../../hooks/useChangeCurrentWorkspace";
import WorkspaceWidgetComponent from "./WorkspaceWidgetComponent";

const WorkspaceWidget = ({ layout }) => {
  const { sites: workspaces } = useSelector(getCurrentUser);

  const changeCurrentWorkspace = useChangeCurrentWorkspace();

  const handleChangeWorkspace = (siteId) => {
    if (siteId > 0) {
      changeCurrentWorkspace(siteId);
    }
  };

  return (
    <WorkspaceWidgetComponent
      layout={layout}
      onChangeWorkspace={handleChangeWorkspace}
      workspaces={workspaces}
    />
  );
};

export default WorkspaceWidget;
